(function() {
  'use strict';

  var galleryImages = Array.from(document.querySelectorAll('.clarisse-gallery-main__img'));
  var thumbs = Array.from(document.querySelectorAll('.clarisse-thumb'));
  var dots = Array.from(document.querySelectorAll('.clarisse-gallery-dots span'));
  var shadeSelect = document.querySelector('.clarisse-shade-select');
  var shadeMenu = document.querySelector('#clarisseShadeMenu');
  var selectedSwatch = document.querySelector('.clarisse-selected-swatch');
  var selectedName = document.querySelector('.clarisse-selected-name');
  var selectedSubtitle = document.querySelector('.clarisse-selected-subtitle');
  var stickyCart = document.querySelector('.clarisse-sticky-cart');
  var variantGrid = document.querySelector('.clarisse-variant-grid');
  var variantPrev = document.querySelector('.clarisse-variant-arrow--prev');
  var variantNext = document.querySelector('.clarisse-variant-arrow--next');
  var resultTrack = document.querySelector('.clarisse-results-track');
  var resultPrev = document.querySelector('.clarisse-results-arrow--prev');
  var resultNext = document.querySelector('.clarisse-results-arrow--next');
  var ingredientTrack = document.querySelector('.clarisse-ingredient-track');
  var ingredientPrev = document.querySelector('.clarisse-ingredient-arrow--prev');
  var ingredientNext = document.querySelector('.clarisse-ingredient-arrow--next');
  var pressCarousel = document.querySelector('[data-press-carousel]');
  var mythsSection = document.querySelector('.clarisse-myths');

  function setActiveMedia(index) {
    galleryImages.forEach(function(img, i) { img.classList.toggle('active', i === index); });
    thumbs.forEach(function(thumb, i) { thumb.classList.toggle('active', i === index); });
    dots.forEach(function(dot, i) { dot.classList.toggle('active', i === index); });
  }

  // Mobile swipe gallery — update dots on scroll
  var galleryMain = document.querySelector('.clarisse-gallery-main');
  if (galleryMain) {
    var scrollTimer;
    galleryMain.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var slideWidth = galleryMain.offsetWidth;
        var activeIndex = Math.round(galleryMain.scrollLeft / slideWidth);
        setActiveMedia(activeIndex);
      }, 50);
    }, { passive: true });
  }

  // Gallery thumbnails
  thumbs.forEach(function(thumb, index) {
    thumb.addEventListener('click', function() {
      setActiveMedia(index);
    });
  });

  // Shade picker
  if (shadeSelect && shadeMenu) {
    shadeSelect.addEventListener('click', function() {
      var willOpen = shadeMenu.hidden;
      shadeMenu.hidden = !willOpen;
      shadeSelect.setAttribute('aria-expanded', String(willOpen));
    });

    shadeMenu.addEventListener('click', function(e) {
      var option = e.target.closest('[data-variant-id]');
      if (option) selectVariant(option);
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.clarisse-shade-picker')) {
        shadeMenu.hidden = true;
        shadeSelect.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Core swatches
  document.querySelectorAll('.clarisse-core-swatches [data-variant-id]').forEach(function(btn) {
    btn.addEventListener('click', function() { selectVariant(btn); });
  });

  var variantMediaMap = {};
  try {
    var mapEl = document.getElementById('clarisseVariantMedia');
    if (mapEl) variantMediaMap = JSON.parse(mapEl.textContent);
  } catch(e) {}

  function selectVariant(option) {
    var variantId = option.dataset.variantId;
    var price = option.dataset.price;
    var swatch = option.dataset.swatch;

    // Update hidden input
    var input = document.querySelector('.clarisse-variant-input');
    if (input) input.value = variantId;

    // Update shade select display
    if (selectedSwatch && swatch) selectedSwatch.style.setProperty('--swatch', swatch);
    if (selectedName) selectedName.textContent = option.querySelector('strong') ? option.querySelector('strong').textContent : option.getAttribute('aria-label');
    if (selectedSubtitle && option.querySelector('em')) selectedSubtitle.textContent = option.querySelector('em').textContent;

    // Update button price
    var addBtn = document.querySelector('.clarisse-add-button > span');
    if (addBtn && price) addBtn.textContent = 'Add — ' + price;

    // Update aria on shade menu
    document.querySelectorAll('.clarisse-shade-menu [data-variant-id]').forEach(function(btn) {
      btn.setAttribute('aria-selected', btn.dataset.variantId === variantId ? 'true' : 'false');
    });

    // Update core swatches
    document.querySelectorAll('.clarisse-core-swatches [data-variant-id]').forEach(function(btn) {
      btn.classList.toggle('active', btn.dataset.variantId === variantId);
    });

    // Close menu
    if (shadeMenu) shadeMenu.hidden = true;
    if (shadeSelect) shadeSelect.setAttribute('aria-expanded', 'false');

    // Update URL
    var url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);

    // Sync gallery to variant image
    var mediaData = variantMediaMap[variantId];
    if (mediaData && mediaData.media_id) {
      var found = false;
      thumbs.forEach(function(thumb, i) {
        if (thumb.dataset.mediaId === mediaData.media_id) {
          setActiveMedia(i);
          found = true;
        }
      });
      if (!found) setActiveMedia(0);
    } else {
      setActiveMedia(0);
    }

    // Sync sticky cart image
    var stickyImg = document.querySelector('.clarisse-sticky-cart__image');
    if (stickyImg && mediaData && mediaData.thumb) {
      stickyImg.src = mediaData.thumb;
    }
  }

  // Sticky cart: show once variant-strip section reaches viewport
  if (stickyCart) {
    var variantStrip = document.querySelector('.clarisse-variant-strip');
    if (variantStrip && 'IntersectionObserver' in window) {
      // Visible while the strip is in view or already scrolled past (above the viewport)
      new IntersectionObserver(function(entries) {
        var entry = entries[0];
        stickyCart.classList.toggle('clarisse-sticky-cart--visible', entry.isIntersecting || entry.boundingClientRect.top < 0);
      }).observe(variantStrip);
    } else {
      var updateStickyCart = function() {
        var threshold = variantStrip ? variantStrip.getBoundingClientRect().top + window.scrollY - window.innerHeight : 300;
        stickyCart.classList.toggle('clarisse-sticky-cart--visible', window.scrollY >= threshold);
      };
      updateStickyCart();
      window.addEventListener('scroll', updateStickyCart, { passive: true });
    }
  }

  // Lazy video — start loading/playing only when near the viewport
  document.querySelectorAll('video[data-lazy-video]').forEach(function(video) {
    function start() {
      video.preload = 'auto';
      var playPromise = video.play();
      if (playPromise) playPromise.catch(function() {});
    }
    if (!('IntersectionObserver' in window)) { start(); return; }
    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        start();
      }
    }, { rootMargin: '600px 0px' });
    observer.observe(video);
  });

  // Scroll carousel helper
  function initScrollCarousel(grid, prev, next) {
    if (!grid) return;
    function getScrollAmount() {
      var card = grid.querySelector('article, .clarisse-result-card, .clarisse-ingredient-card');
      if (!card) return 300;
      var gap = parseFloat(window.getComputedStyle(grid).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    if (prev) prev.addEventListener('click', function() { grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function() { grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); });
  }

  initScrollCarousel(variantGrid, variantPrev, variantNext);
  initScrollCarousel(resultTrack, resultPrev, resultNext);
  initScrollCarousel(ingredientTrack, ingredientPrev, ingredientNext);

  // Press carousel
  if (pressCarousel) {
    var pressSlides = Array.from(pressCarousel.querySelectorAll('.clarisse-snb-featured__slide'));
    var pressPrev = pressCarousel.querySelector('.clarisse-snb-featured__arrow--prev');
    var pressNext = pressCarousel.querySelector('.clarisse-snb-featured__arrow--next');
    var pressDotsWrap = pressCarousel.querySelector('.clarisse-snb-featured__dots');
    var activePressSlide = 0;

    pressSlides.forEach(function(_, index) {
      var dot = document.createElement('button');
      dot.className = 'clarisse-snb-featured__dot' + (index === 0 ? ' is-active' : '');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show press quote ' + (index + 1));
      dot.addEventListener('click', function() { setPressSlide(index); });
      if (pressDotsWrap) pressDotsWrap.appendChild(dot);
    });

    var pressDots = Array.from(pressCarousel.querySelectorAll('.clarisse-snb-featured__dot'));

    function setPressSlide(index) {
      if (!pressSlides.length) return;
      activePressSlide = (index + pressSlides.length) % pressSlides.length;
      pressSlides.forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === activePressSlide);
      });
      pressDots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === activePressSlide);
      });
    }

    if (pressPrev) pressPrev.addEventListener('click', function() { setPressSlide(activePressSlide - 1); });
    if (pressNext) pressNext.addEventListener('click', function() { setPressSlide(activePressSlide + 1); });
    setPressSlide(0);

    // Auto-advance
    setInterval(function() { setPressSlide(activePressSlide + 1); }, 5000);
  }

  // Myths carousel
  if (mythsSection) {
    var mythSlides = Array.from(mythsSection.querySelectorAll('.clarisse-myths__slide'));
    var mythDots = Array.from(mythsSection.querySelectorAll('.clarisse-myths__dot'));

    function setMythSlide(index) {
      if (!mythSlides.length) return;
      var activeIndex = Math.max(0, Math.min(index, mythSlides.length - 1));
      mythSlides.forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === activeIndex);
        slide.classList.toggle('clarisse-myths__slide--active', i === activeIndex);
      });
      mythDots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
        dot.classList.toggle('clarisse-myths__dot--active', i === activeIndex);
      });
    }

    mythDots.forEach(function(dot, index) {
      dot.addEventListener('click', function() { setMythSlide(index); });
    });
    setMythSlide(0);
  }

})();
